import React, { useState, useEffect, useRef, useCallback } from "react";
import logo1 from "../../../images/MAAMAAS_LOGO.png"; // Default logo
import banner from "../../../images/aaaservices/zomato.avif"; // Default banner src/images/zomato.avif
import { Link } from "react-router-dom";
import {
    FaWhatsapp,
    FaInstagram,
    FaFacebookF,
    FaYoutube,
    FaEdit, // Keep if used elsewhere, otherwise can remove
} from "react-icons/fa";
import Aboutmaamaas from "../HomeManagment/Food/Aboutmaamaas";
import LeadershipCard from "../HomeManagment/Food/LeadershipCard";
import MissionVisionCards from "../HomeManagment/Food/MissionVisionCards";
import GalleryCards from "../HomeManagment/Food/GalleryCards";
// import Best from "./Best"; // Assuming Best is not used directly here
import Bestdeals from "../HomeManagment/Food/Bestdeals";
import { FaChevronDown, FaChevronUp, FaCommentAlt, FaPaperPlane } from "react-icons/fa";


const Logisticsladingpage = () => {
    const [showMore, setShowMore] = useState(false);
    const [showMoree, setShowMoree] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
    const scrollContainerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    // const fileInputRef = useRef(null); // Keep if used elsewhere

    // State for modal visibility
    const [showModal, setShowModal] = useState(false);

    // State for currently displayed data (fetched or default)
    const [currentName, setCurrentName] = useState("MAAMAAS HOUSE"); // Default name
    const [currentYear, setCurrentYear] = useState("1997"); // Default year
    const [currentWhatsapp, setCurrentWhatsapp] = useState("");
    const [currentInstagram, setCurrentInstagram] = useState("");
    const [currentFacebook, setCurrentFacebook] = useState("");
    const [currentTwitter, setCurrentTwitter] = useState("");
    const [currentBanner, setCurrentBanner] = useState(banner); // Default banner image
    const [currentLogo, setCurrentLogo] = useState(logo1); // Default logo image
    const [currentBannerId, setCurrentBannerId] = useState(null); // <<< State for existing Banner ID

    // State for user ID
    const [userId, setUserId] = useState("");

    // State for form inputs within the modal
    const [name, setName] = useState("");
    const [year, setYear] = useState("");
    const [bannerBase64, setBannerBase64] = useState(null); // Use null initially
    const [logoBase64, setLogoBase64] = useState(null); // Use null initially
    const [whatsapp, setWhatsapp] = useState("");
    const [instagram, setInstagram] = useState("");
    const [facebook, setFacebook] = useState("");
    const [twitter, setTwitter] = useState("");
    const [vendorId, setVendorId] = useState(null);
    const isMobile = window.innerWidth <= 768;
    // Optional image states (if needed in payload, currently not used in form)
    // const [whatsappImage, setWhatsappImage] = useState("");
    // const [instagramImage, setInstagramImage] = useState("");
    // const [facebookImage, setFacebookImage] = useState("");
    // const [twitterImage, setTwitterImage] = useState("");

    // Fetch userId from localStorage on component mount
    const [isOpen, setIsOpen] = useState(false);
    const [message, setMessage] = useState("");

    const [ticketType, setTicketType] = useState("");

    const [attachment, setAttachment] = useState(""); // base64 image

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const result = reader.result;
                // Ensure we only get base64 data (after the comma)
                const base64Data = result.split(',')[1];
                setAttachment(base64Data);
            };
            reader.readAsDataURL(file);
        }
    };



    const handleSendTicket = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("Vendor ID or Token not found in localStorage.");
            return;
        }

        if (!ticketType || !message) {
            alert("Please fill all the fields");
            return;
        }

        const payload = {
            vendorId: Number(vendorId),
            ticketType,
            message,
            attachmentUrl: attachment || "", // base64 encoded image
        };

        try {
            const response = await fetch(
                "https://backend.maamaas.com/food/vendor-tickets/create",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                    body: JSON.stringify(payload),
                }
            );

            const result = await response.json();

            if (response.ok) {
                alert("Ticket submitted successfully!");
                setTicketType("");
                setMessage("");
                setAttachment("");
                setIsOpen(false);
            } else {
                console.error("API Error:", result);
                alert(result.message || "Failed to submit ticket.");
            }
        } catch (error) {
            console.error("Fetch Error:", error);
            alert("Something went wrong while submitting the ticket.");
        }
    };


    useEffect(() => {
        const storedVendorId = localStorage.getItem("vendorId");
        setVendorId(storedVendorId);
    }, []);

    // --- Function to Fetch Banner Data ---
    // Wrapped in useCallback to stabilize its identity if needed as a dependency elsewhere
    const fetchBannerData = useCallback(async () => {
        const currentVendorId = localStorage.getItem("vendorId"); // Fetch fresh vendorId
        const token = localStorage.getItem("authToken"); // ✅ Get token from localStorage

        if (!currentVendorId || !token) {
            console.warn("fetchBannerData: Missing vendorId or authToken.");
            // Reset to defaults if user logs out / no vendor
            setCurrentBanner(banner);
            setCurrentLogo(logo1);
            setCurrentName("MAAMAAS HOUSE");
            setCurrentYear("1997");
            setCurrentWhatsapp("");
            setCurrentInstagram("");
            setCurrentFacebook("");
            setCurrentTwitter("");
            setCurrentBannerId(null);
            setIsLoading(false);
            return;
        }

        setVendorId(currentVendorId); // Update state if necessary
        setIsLoading(true);

        try {
            console.log("Current Vendor ID:", currentVendorId);
            const fetchUrl = `https://backend.maamaas.com/food/banner/vendor/${currentVendorId}`;
            console.log(`Fetching banner data from: ${fetchUrl}`);

            const response = await fetch(fetchUrl, {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}` // ✅ Include token
                }
            });

            if (response.status === 404) {
                console.log("No banner data found (404). Using defaults.");
                setCurrentBanner(banner);
                setCurrentLogo(logo1);
                setCurrentName("MAAMAAS HOUSE");
                setCurrentYear("1997");
                setCurrentWhatsapp("");
                setCurrentInstagram("");
                setCurrentFacebook("");
                setCurrentTwitter("");
                setCurrentBannerId(null);
                setIsLoading(false);
                return;
            }

            if (!response.ok) {
                let errorMsg = `Failed to fetch banner data. Status: ${response.status}`;
                try {
                    const errorBody = await response.text();
                    errorMsg += ` Details: ${errorBody}`;
                } catch (e) {
                    // ignore
                }
                throw new Error(errorMsg);
            }

            const data = await response.json();
            console.log("Received banner data:", data);

            setCurrentBanner(
                data.companyBanner ? `data:image/jpeg;base64,${data.companyBanner}` : banner
            );
            setCurrentLogo(
                data.companyLogo ? `data:image/png;base64,${data.companyLogo}` : logo1
            );
            setCurrentName(data.companyName || "MAAMAAS HOUSE");
            setCurrentYear(data.establishedYear || "1997");
            setCurrentWhatsapp(data.whatsappLink || "");
            setCurrentInstagram(data.instagramLink || "");
            setCurrentFacebook(data.facebookLink || "");
            setCurrentTwitter(data.twitterLink || "");
            setCurrentBannerId(data.bannerId || null);
        } catch (error) {
            console.error("Error fetching banner data:", error);
            setCurrentBanner(banner);
            setCurrentLogo(logo1);
            setCurrentName("MAAMAAS HOUSE");
            setCurrentYear("1997");
            setCurrentWhatsapp("");
            setCurrentInstagram("");
            setCurrentFacebook("");
            setCurrentTwitter("");
            setCurrentBannerId(null);
        } finally {
            setIsLoading(false);
        }
    }, []); // No dependencies — vendorId comes from localStorage


    // --- Fetch banner data when component mounts or vendorId changes ---
    useEffect(() => {
        fetchBannerData();
    }, [vendorId, fetchBannerData]);


    // --- Function to handle image selection and conversion to Base64 ---
    const handleImageUpload = (e, type) => {
        const file = e.target.files[0];
        if (!file) return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const base64 = reader.result.split(",")[1]; // Get Base64 string only
            switch (type) {
                case "banner": setBannerBase64(base64); break;
                case "logo": setLogoBase64(base64); break;
                // Add other types if needed
                // case "whatsapp": setWhatsappImage(base64); break;
                // case "instagram": setInstagramImage(base64); break;
                // case "facebook": setFacebookImage(base64); break;
                // case "twitter": setTwitterImage(base64); break;
                default: break;
            }
            // Reset the file input value so the same file can be selected again if needed
            e.target.value = null;
        };
        reader.onerror = (error) => {
            console.error("Error reading file:", error);
            alert("Failed to read the selected image file.");
        };
        reader.readAsDataURL(file);
    };


    // --- Function to Open Modal and Pre-fill Form for Editing ---
    const handleOpenModal = () => {
        if (currentBannerId) {
            // --- EDIT MODE: Pre-fill form with current data ---
            console.log("Opening modal in EDIT mode for bannerId:", currentBannerId);
            setName(currentName);
            setYear(currentYear);
            setWhatsapp(currentWhatsapp);
            setInstagram(currentInstagram);
            setFacebook(currentFacebook);
            setTwitter(currentTwitter);
            // **Crucially reset image base64 state - user MUST re-upload for edit**
            // (Based on current validation logic requiring both images)
            setBannerBase64(null);
            setLogoBase64(null);
        } else {
            // --- ADD MODE: Clear form ---
            console.log("Opening modal in ADD mode");
            setName("");
            setYear("");
            setWhatsapp("");
            setInstagram("");
            setFacebook("");
            setTwitter("");
            setBannerBase64(null);
            setLogoBase64(null);
        }
        setShowModal(true); // Open the modal
    };


    // --- Function to Handle Form Submission (Add or Edit) ---
    const handleFormSubmit = async () => {
        const vendorId = localStorage.getItem("vendorId"); // ✅ Use vendorId
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            alert("User session expired or not found. Please log in again.");
            return;
        }

        if (!name || !year || !bannerBase64 || !logoBase64) {
            alert("Please fill Company Name, Year, and upload BOTH a new Logo and a new Banner image.");
            return;
        }

        const isEditing = !!currentBannerId;
        let url = "";
        let method = "";
        let payload = {};

        if (isEditing) {
            method = "PUT";
            url = `https://backend.maamaas.com/food/banner/edit/${currentBannerId}`;
            payload = {
                bannerId: currentBannerId,
                companyName: name,
                establishedYear: year,
                whatsappLink: whatsapp,
                instagramLink: instagram,
                facebookLink: facebook,
                twitterLink: twitter,
                companyLogo: logoBase64,
                companyBanner: bannerBase64
            };
        } else {
            method = "POST";
            url = `https://backend.maamaas.com/food/banner/add/${vendorId}`;
            payload = {
                companyName: name,
                establishedYear: year,
                whatsappLink: whatsapp,
                instagramLink: instagram,
                facebookLink: facebook,
                twitterLink: twitter,
                companyLogo: logoBase64,
                companyBanner: bannerBase64
            };
        }

        try {
            const response = await fetch(url, {
                method: method,
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: JSON.stringify(payload)
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const result = await response.json();
            console.log("Form submission successful:", result);
            alert("Banner saved successfully.");

        } catch (error) {
            console.error("Error submitting form:", error);
            alert("Failed to submit banner. Please try again.");
        }
    };




    // --- Placeholder data for the right-side scroll section ---
    const orderPosts = [
        { dishId: 1, orderType: "Create Limited-Time Deals!" },
        { dishId: 2, orderType: "Highlight Your Best Sellers!" },
        { dishId: 3, orderType: "Exclusive Discount Campaigns" },
        { dishId: 4, orderType: " Create Your Festive Offers" }, // Changed ID for uniqueness if needed
        { dishId: 5, orderType: " Create Your Festive Best Deals" }, // Changed ID
        { dishId: 6, orderType: " Create Your Own Ads" }, // Changed ID
        { dishId: 7, orderType: "Exclusive Discount Campaigns" }, // Changed ID
        { dishId: 8, orderType: " Create Your Festive Offers" }, // Changed ID
        { dishId: 9, orderType: " Create Your Festive Best Deals" }, // Changed ID
        { dishId: 10, orderType: " Create Your Own Ads" }, // Changed ID
    ];

    // --- Style for buttons below banner ---
    const buttonStyle = {
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "green",
        color: "white",
        cursor: "pointer",
        marginTop: "10px",
        fontWeight: "bold"
    };
    const buttonStylee = {
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "8px",
        border: "none",
        backgroundColor: "blue",
        color: "white",
        cursor: "pointer",
        marginTop: "10px",
        fontWeight: "bold"
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-2"></div>
                <div
                    style={{ marginTop: isMobile ? '50px' : '0px' }}
                    className="col-lg-7 col-md-7 col-sm-12 col-12 subscription-home"
                >

                    <p
                        className="breadcrumb maamaas-home-bredcum"
                        style={{
                            position: "fixed",
                            top: isMobile ? "50px" : "80px",
                            left: isMobile ? "5px" : "275px",
                            width: "100%",
                            backgroundColor: "#fff",
                            zIndex: 1000,
                            padding: "10px 0",
                            fontSize: isMobile ? "14px" : "18px",
                            fontWeight: isMobile ? "normal" : "bold",
                            textAlign: "center",
                            margin: 0,
                        }}
                    >
                        <Link
                            to="/Newmainlandingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Home
                        </Link>
                        <span className="separator"> &gt; </span>
                        <Link
                            to="/foodladingpage"
                            style={{
                                color: "purple",
                                fontWeight: "bold",
                                textDecoration: "none",
                            }}
                        >
                            Logistics & Supply
                        </Link>

                        {/* <span className="separator"> &gt; </span> */}



                    </p>
                    <div
                        style={{
                            overflowY: "auto",
                            scrollbarWidth: "none",
                            maxHeight: "calc(100vh - 150px)",
                            msOverflowStyle: "none",
                        }}
                        className="hide-scrollbar homeheight"
                    >
                        {/* Banner Section */}
                        <div style={{ position: "relative", marginBottom: "10px" }}>
                            {isLoading && <div style={{ textAlign: 'center', padding: '50px' }}>Loading Banner...</div>}
                            {!isLoading && (
                                <>
                                    <div style={{ position: "relative", width: "100%", height: "450px", borderRadius: "20px", overflow: "hidden" }}>
                                        <img
                                            src={currentBanner || banner}
                                            alt="Banner"
                                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                        />
                                        <div
                                            style={{
                                                position: "absolute",
                                                top: 0,
                                                left: 0,
                                                width: "100%",
                                                height: "100%",
                                                backgroundColor: "rgba(0, 0, 0, 0.4)", // <-- adjust color and opacity here
                                                borderRadius: "20px"
                                            }}
                                        />
                                    </div>
                                    {/* Logo */}
                                    <img
                                        src={currentLogo || logo1} // Use currentLogo, fallback to default import
                                        alt="Logo"
                                        style={{
                                            position: "absolute",
                                            top: "10px", // Adjusted position
                                            left: "-10px",
                                            height: "120px", // Adjusted size
                                            width: "auto", // Maintain aspect ratio
                                            maxWidth: "160px",
                                            zIndex: 1,
                                            padding: '5px',
                                            borderRadius: '8px'
                                        }}
                                        className="current-image"
                                    />

                                    {/* Company Name */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "0px",
                                            // left: "250px", 
                                            // right: "180px",
                                            color: "white",
                                            fontSize: "38px", // Adjusted size
                                            fontWeight: "bold",
                                            textShadow: "2px 2px 4px rgba(0, 0, 0, 0.8)",
                                            zIndex: 1,
                                            //  backgroundColor: 'rgba(0,0,0,0.3)', // Slight background
                                            padding: '5px 10px',
                                            borderRadius: '5px',
                                            display: 'inline-block', // Prevent stretching full width
                                            maxWidth: 'calc(100% - 350px)' // Prevent overlap
                                        }}
                                        className="current-name-data"
                                    >
                                        {currentName}
                                    </div>

                                    {/* Established Year */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            top: "50px", // Below name
                                            // left: "440px", 
                                            color: "white",
                                            fontSize: "28px", // Adjusted size
                                            fontWeight: "bold",
                                            textShadow: "1px 1px 3px rgba(0, 0, 0, 0.7)",
                                            zIndex: 1,

                                            padding: '3px 8px',
                                            borderRadius: '5px'
                                        }}
                                        className="since-lastyear"
                                    >
                                        Since {currentYear}
                                    </div>

                                    {/* "Add/Edit" Button - Now uses handleOpenModal */}
                                    <button
                                        onClick={handleOpenModal} // <<< Use the new handler
                                        style={{
                                            position: "absolute",
                                            top: "20px", // Align with name/logo top
                                            right: "20px",
                                            color: "white",
                                            padding: "8px 15px", // Adjusted padding
                                            fontWeight: "bold",
                                            background: "#b15cd6",
                                            borderRadius: "5px",
                                            border: "none",
                                            zIndex: 2, // Above other elements
                                            cursor: "pointer",
                                            fontSize: '14px'
                                        }}
                                    >
                                        {currentBannerId ? "Edit Info" : "Add Info"} {/* Dynamic Text */}
                                    </button>

                                    {/* Social Icons Section */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            bottom: "40px", // Positioned below the banner bottom edge
                                            left: 0,
                                            right: 0,
                                            display: "flex",
                                            justifyContent: "center", // Center icons horizontally
                                            gap: "30px", // Space between icons
                                            zIndex: 1,
                                        }}
                                    >
                                        {[
                                            { label: "WhatsApp", icon: <FaWhatsapp size={40} />, color: "#25D366", link: currentWhatsapp },
                                            { label: "Instagram", icon: <FaInstagram size={40} />, color: "#E4405F", link: currentInstagram },
                                            { label: "Facebook", icon: <FaFacebookF size={40} />, color: "#1877F2", link: currentFacebook },
                                            { label: "Twitter", icon: <FaYoutube size={40} />, color: "#FF0000", link: currentTwitter },
                                        ].map((item, idx) => (
                                            item.link && ( // Only display icon if link exists
                                                <a
                                                    key={idx}
                                                    href={item.link}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    title={item.label}
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        alignItems: "center",
                                                        textDecoration: 'none',
                                                        color: item.color // Use specific color
                                                    }}
                                                >
                                                    {item.icon}
                                                    {/* Optional: Show label below icon
                                <span style={{ fontSize: "12px", marginTop: "4px", color: "#333" }}>
                                {item.label}
                                </span>
                                */}
                                                </a>
                                            )
                                        ))}
                                    </div>
                                </>
                            )}
                        </div> {/* End Banner Section */}

                        {/* Buttons Below Banner (COM001, OPEN, Know More) */}


                        <div className="responsive-button-group">
                            <div style={{ display: "flex", justifyContent: "center", gap: "0px", }} className="maamaas-home-buttons">
                                <div
                                    style={{
                                        padding: "10px 20px",
                                        fontSize: "14px",
                                        borderRadius: "8px",
                                        border: "none",
                                        cursor: "pointer"
                                    }}
                                >
                                    <p style={{ margin: 0, color: "#4caf50", fontWeight: "bold" }}>⏰ 09:00 AM</p>
                                    <p style={{ margin: 0, color: "red", fontWeight: "bold" }}>⏰ 10:00 PM</p>
                                </div>
                            </div>
                            <button style={buttonStyle} onClick={() => setShowMore(!showMore)}>
                                {showMore ? "Show Less" : "Know More"}
                            </button>
                            <button style={buttonStylee} onClick={() => setShowMoree(!showMoree)}>
                                {showMoree ? "Hide Gallery" : "View Gallery"}
                            </button>
                        </div>
                        {showMore && (
                            <div>
                                <Aboutmaamaas />
                                <MissionVisionCards />
                                <LeadershipCard />

                            </div>
                        )}
                        {showMoree && (
                            <div>
                                <GalleryCards />
                            </div>
                        )}

                        {/* Always Rendered Sections */}
                        {/* <div className="gallery-cards-data">
                            <Bestdeals />
                        </div> */}

                        {/* --- Modal for Adding/Editing Details --- */}
                        {showModal && (
                            <div
                                style={{ /* Modal Overlay Styles */
                                    position: "fixed", top: 0, left: 0, right: 0, bottom: 0,
                                    backgroundColor: "rgba(0,0,0,0.6)", display: "flex",
                                    justifyContent: "center", alignItems: "center", zIndex: 1050, // High z-index
                                    padding: '20px' // Padding for smaller screens
                                }}
                            >
                                <div
                                    style={{ /* Modal Content Styles */
                                        backgroundColor: "white", padding: "25px", borderRadius: "10px",
                                        width: "90%", maxWidth: "450px", // Responsive width
                                        maxHeight: '90vh', overflowY: 'auto', // Scrollable content
                                        textAlign: "center", position: 'relative', // For close button positioning
                                        boxShadow: '0 5px 15px rgba(0,0,0,0.3)'
                                    }}
                                >
                                    {/* Modal Header */}
                                    <div style={{ display: "flex", justifyContent: "space-between", alignItems: 'center', marginBottom: "15px", borderBottom: '1px solid #eee', paddingBottom: '10px' }}>
                                        <span style={{ fontSize: "18px", fontWeight: "bold" }}>
                                            {currentBannerId ? "Update Banner Details" : "Upload Banner Details"} {/* Dynamic Title */}
                                        </span>
                                        <span onClick={() => setShowModal(false)} style={{ fontSize: "24px", cursor: "pointer", color: '#888', lineHeight: '1' }}>
                                            × {/* Nicer close icon */}
                                        </span>
                                    </div>

                                    {/* User ID (Read Only) - Important Context */}
                                    <input
                                        type="text"
                                        value={`vendor ID: ${vendorId}`} // Display clearly
                                        readOnly
                                        style={{ padding: "8px", fontSize: "14px", marginBottom: "15px", width: "100%", borderRadius: "4px", border: "1px solid #ccc", backgroundColor: '#f0f0f0', color: '#555' }}
                                    />

                                    {/* Form Inputs */}
                                    <input type="text" placeholder="Enter Company Name *" value={name} onChange={(e) => setName(e.target.value)} style={{ margin: "10px 0", padding: "10px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />
                                    <input type="number" placeholder="Enter Establishment Year *" value={year} onChange={(e) => setYear(e.target.value)} style={{ margin: "10px 0", padding: "10px", width: "100%", borderRadius: "4px", border: "1px solid #ccc" }} />

                                    {/* Banner Image Upload */}
                                    <label style={{ textAlign: "left", display: "block", marginTop: "15px", marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
                                        Banner Image * {currentBannerId ? "(Re-upload required)" : ""}
                                    </label>
                                    <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, "banner")} style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }} />
                                    {/* Optional Preview */}
                                    {/* {bannerBase64 && <img src={`data:image/jpeg;base64,${bannerBase64}`} alt="Banner Preview" width="100" style={{marginTop: '5px'}}/>} */}


                                    {/* Logo Image Upload */}
                                    <label style={{ textAlign: "left", display: "block", marginTop: "15px", marginBottom: '5px', fontWeight: 'bold', fontSize: '14px' }}>
                                        Logo Image * {currentBannerId ? "(Re-upload required)" : ""}
                                    </label>
                                    <input type="file" accept="image/*" onChange={(e) => handleImageUpload(e, "logo")} style={{ width: '100%', padding: '10px', border: '1px solid #ccc', borderRadius: '4px' }} />
                                    {/* Optional Preview */}
                                    {/* {logoBase64 && <img src={`data:image/png;base64,${logoBase64}`} alt="Logo Preview" width="60" style={{marginTop: '5px'}} />} */}


                                    {/* Social Links Section */}
                                    <div style={{ marginTop: '20px', borderTop: '1px solid #eee', paddingTop: '15px' }}>
                                        <p style={{ textAlign: 'left', fontSize: '14px', color: '#555', marginBottom: '15px' }}>Social Media Links (Optional):</p>
                                        {[
                                            { label: "WhatsApp", icon: <FaWhatsapp size={25} color="#25D366" />, value: whatsapp, setter: setWhatsapp },
                                            { label: "Instagram", icon: <FaInstagram size={25} color="#E4405F" />, value: instagram, setter: setInstagram },
                                            { label: "Facebook", icon: <FaFacebookF size={25} color="#1877F2" />, value: facebook, setter: setFacebook },
                                            { label: "Twitter", icon: <FaYoutube size={25} color="#1DA1F2" />, value: twitter, setter: setTwitter },
                                        ].map((field, idx) => (
                                            <div key={idx} style={{ margin: "10px 0" }}>
                                                <div style={{ display: "flex", alignItems: "center", gap: '10px' }}>
                                                    <div style={{ width: "30px", textAlign: "center" }}>{field.icon}</div>
                                                    <input
                                                        type="text"
                                                        placeholder={`${field.label} Link`}
                                                        value={field.value}
                                                        onChange={(e) => field.setter(e.target.value)}
                                                        style={{ flex: 1, padding: "10px", borderRadius: '4px', border: '1px solid #ccc' }}
                                                    />
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Submit / Update Button */}
                                    <button
                                        onClick={handleFormSubmit}
                                        disabled={isLoading} // Disable button while submitting
                                        style={{
                                            backgroundColor: isLoading ? '#ccc' : "#4CAF50", // Indicate loading state
                                            color: "white",
                                            padding: "12px 20px",
                                            border: "none",
                                            borderRadius: "5px",
                                            cursor: isLoading ? 'not-allowed' : 'pointer',
                                            width: "100%",
                                            marginTop: "25px",
                                            fontSize: '16px',
                                            fontWeight: 'bold'
                                        }}
                                    >
                                        {isLoading ? 'Submitting...' : (currentBannerId ? "Update All Details" : "Submit")} {/* Dynamic Button Text */}
                                    </button>
                                    <p style={{ fontSize: '12px', color: '#888', marginTop: '10px' }}>* Required fields</p>
                                </div>
                            </div>
                        )} {/* End Modal */}

                    </div> {/* End Main Content Scrollable Area */}
                </div> {/* End col-lg-7 */}

                {/* Right Sidebar Section */}
                <div className="col-lg-3">
                    <div
                        style={{
                            position: "fixed",
                            top: "110px",
                            bottom: "20px",
                            right: "16px",
                            width: "300px",
                            borderRadius: "8px",
                            padding: "10px",

                            display: 'flex',
                            flexDirection: 'column',
                        }}
                        className="mobilescroll"
                    >

                        <div
                            ref={scrollContainerRef}
                            style={{
                                flexGrow: 1,
                                overflowY: "auto",
                                paddingRight: "5px",
                                scrollbarWidth: "none",
                                msOverflowStyle: "none",
                            }}
                            className="hide-scrollbar"
                            onMouseEnter={() => setIsHovered(true)}
                            onMouseLeave={() => setIsHovered(false)}
                        >

                            {orderPosts.map((post, index) => (
                                <div
                                    key={`${post.dishId}-${index}`}
                                    className="card scroll-data-responsive"
                                    style={{
                                        height: "120px", marginBottom: "15px", background: "#b15cd6",
                                        borderRadius: "8px", boxShadow: "0px 2px 4px rgba(0,0,0,0.2)",
                                        overflow: "hidden", padding: "15px", position: "relative", color: '#fff'
                                    }}
                                >
                                    <h6 style={{ fontWeight: 'bold', marginBottom: 'auto' }}>{post.orderType}</h6>
                                    <Link to="/promotions" style={{ textDecoration: 'none' }}>
                                        <button
                                            style={{
                                                position: "absolute", bottom: "15px", right: "65px",
                                                padding: "6px 12px", backgroundColor: "#fff", color: "#b15cd6",
                                                fontSize: "13px", fontWeight: "bold", border: "none",
                                                borderRadius: "5px", cursor: "pointer", zIndex: 5,
                                            }}
                                        >
                                            Add Promotions
                                        </button>
                                    </Link>
                                </div>
                            ))}
                        </div>

                        <div
                            style={{
                                position: "fixed",
                                bottom: "0px",
                                right: "15px",
                                width: "300px",
                                backgroundColor: "#fff",
                                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)",
                                borderRadius: "10px",
                                overflow: "hidden",
                                transition: "height 0.3s ease-in-out",
                                height: isOpen ? "400px" : "50px",
                                zIndex: 9999,
                            }}
                        >

                            <div
                                style={{
                                    backgroundColor: "#b15cd6",
                                    color: "#fff",
                                    padding: "10px",
                                    fontWeight: "bold",
                                    textAlign: "center",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "space-between",
                                    cursor: "pointer",
                                }}
                                onClick={() => setIsOpen(!isOpen)}
                            >
                                <FaCommentAlt style={{ marginLeft: "10px" }} />
                                <span style={{ flexGrow: 1, textAlign: "center" }}>Support</span>
                                {isOpen ? <FaChevronDown style={{ marginRight: "10px" }} /> : <FaChevronUp style={{ marginRight: "10px" }} />}
                            </div>

                            {/* Chat Content */}
                            {isOpen && (
                                <div
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        flex: 1,
                                        overflowY: "auto",
                                        padding: "10px",
                                        height: "352px",
                                        scrollbarWidth: "none"
                                    }}
                                >
                                    <h4 style={{ textAlign: "center", marginBottom: "10px" }}>Raise a Ticket</h4>

                                    {/* Ticket Type Dropdown */}
                                    <label style={{ fontWeight: "bold" }}>Ticket Type</label>
                                    <select
                                        value={ticketType}
                                        onChange={(e) => setTicketType(e.target.value)}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            outline: "none",
                                        }}
                                    >
                                        <option value="">Select Ticket Type</option>
                                        <option value="PAYOUT_ISSUE">Payout Issue</option>
                                        <option value="SUBSCRIPTION_ISSUE">Subscription Issue</option>
                                        <option value="ORDER_COMPLAINT">Order Complaint</option>
                                        <option value="TECHNICAL_SUPPORT">Technical Support</option>
                                        <option value="OTHER">Other</option>
                                    </select>

                                    {/* Message Input */}
                                    <label style={{ fontWeight: "bold" }}>Message</label>
                                    <input
                                        value={message}
                                        onChange={(e) => setMessage(e.target.value)}
                                        placeholder="Type your Issue here..."
                                        rows={3}
                                        style={{
                                            marginBottom: "10px",
                                            padding: "8px",
                                            borderRadius: "5px",
                                            border: "1px solid #ccc",
                                            height: "50px"

                                        }}
                                    />

                                    {/* Attachment Upload */}
                                    <label style={{ fontWeight: "bold" }}>Attachment</label>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={handleImageChange}
                                        style={{ marginBottom: "10px" }}
                                    />

                                    {/* Submit Button */}
                                    <button
                                        onClick={handleSendTicket}
                                        style={{
                                            padding: "10px",
                                            backgroundColor: "#b15cd6",
                                            color: "#fff",
                                            border: "none",
                                            borderRadius: "5px",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                        }}
                                    >
                                        Send Ticket
                                    </button>
                                </div>
                            )}

                        </div>


                    </div>
                </div>
            </div>
        </div>
    );
};

export default Logisticsladingpage;